export const educationData = [
    {
        id: 1,
        institution: 'The University of Texas at Austin',
        course: 'Bachelor of Engineering',
        startYear: '2009',
        endYear: '2013'
    }
]